import { api } from '@creditsights/api-ui-web';
// eslint-disable-next-line import/no-unresolved
import { NO_DATA } from '../../Base.constants';
import { CompanyDeal, DealSecurityType, ModerationStatus } from '../../models/CompanyDeal';

const moduleV1Uri = 'common/v1/securities';

export interface DealsParams {
  securityTypes?: DealSecurityType[];
  marketStatuses?: string[];
  take?: number;
  sort?: string;
  enabled?: boolean;
  excludeMarketStatuses?: boolean;
}

const getSizeAndCurrency = (security: any) => {
  return security.size ? `${security.size} ${security.currency}` : NO_DATA;
};

export const fetchCompanyDeals = async (companyId: string, params?: DealsParams): Promise<CompanyDeal[]> => {
  const filters = {
    cs_companyid: {
      values: [companyId],
    },
    moderation: { values: [ModerationStatus.PUBLISHED, ModerationStatus.SENT] },
    ...(params?.securityTypes && { security_type: { values: params?.securityTypes } }),
    ...(params?.marketStatuses && {
      deal_status: params?.excludeMarketStatuses
        ? { excluded_values: params?.marketStatuses }
        : { values: params?.marketStatuses },
    }),
  };
  const { data } = await api.post(moduleV1Uri, {
    skip: 0,
    take: params?.take ?? 100,
    sortDesc: true,
    ...(params?.sort && { sort: params?.sort }),
    filters,
  });

  return (data.results || []).map((security) => {
    const companyDeals: CompanyDeal = {
      securityType: security.security_type,
      marketStatus: security.market_status,
      meetingDate: security.launch_date,
      dealType: security.deal_type ?? NO_DATA,
      booksClosed: security.security_type === DealSecurityType.Bond ? security.pricing_date : security.commitment_date,
      size: getSizeAndCurrency(security),
      uop: security.uop ?? NO_DATA,
    };

    return companyDeals;
  });
};
